import { Controller } from "@hotwired/stimulus"
import { track, trackingAllowed } from "../analytics"

// Runs once per marketing page load. Two things, kept apart:
// - The cookie-free page-view count (PageViewsController): path and referring site only, nothing
//   that links one page load to another. Unchanged, for every visitor who doesn't ask not to be
//   tracked.
// - The same visit as analytics events (see analytics.js): page_viewed, landing_page_viewed for
//   the first page of a browser session, and pricing_viewed or docs_viewed where they apply, with
//   any campaign tags from the address. These are linked to one visitor only if they agreed.
const UTM = [ "utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term" ]

export default class extends Controller {
  connect() {
    if (!trackingAllowed()) return

    const body = new URLSearchParams({ path: location.pathname, referrer: document.referrer })
    if (navigator.sendBeacon) {
      navigator.sendBeacon("/page_views", new Blob([ body ], { type: "application/x-www-form-urlencoded" }))
    } else {
      fetch("/page_views", { method: "POST", body, keepalive: true })
    }

    const params = new URLSearchParams(location.search)
    const page = { path: location.pathname, referrer_host: this.referrerHost() }
    UTM.forEach((key) => { if (params.get(key)) page[key] = params.get(key) })
    track("page_viewed", page)

    let firstInSession = false
    try {
      firstInSession = !sessionStorage.getItem("fo_landed")
      sessionStorage.setItem("fo_landed", "1")
    } catch { firstInSession = false }
    if (firstInSession) track("landing_page_viewed", { ...page, first_visit: !document.cookie.includes("fo_aid=") })

    if (location.pathname.startsWith("/pricing")) track("pricing_viewed", { path: location.pathname, interval: params.get("interval") || "monthly" })
    if (location.pathname.startsWith("/documentation") || location.pathname.startsWith("/languages")) {
      track("docs_viewed", { path: location.pathname, section: location.hash.slice(1) || null, language: location.pathname.split("/")[2] || null })
    }
  }

  referrerHost() {
    try {
      const host = new URL(document.referrer).host
      return host && host !== location.host ? host : null
    } catch { return null }
  }
}
